<template>
  <el-row style="width: 100%;margin-top: 87px;">
    <!--  轮播图  -->
    <el-row style="height: 960px;">
      <el-carousel :interval="4000" trigger="click" arrow="always" height="960px">
        <el-carousel-item v-for="(item, i) in imgList" :key="i">
          <el-row :style="{backgroundImage: 'url(' + item + ')', width: '100%', height: '100%', backgroundSize:'100% 100%', backgroundRepeat:'no-repeat'}">
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <!--  关于瑜岿  -->
    <about-us />
    <!--  解决方案  -->
    <solutions />
    <!--  软件中心  -->
    <software />
    <!--  硬件中心  -->
    <hardware />
    <!--  新闻资讯  -->
    <news @clickContent="clickContent" />
  </el-row>
</template>

<script>
import AboutUs from './AboutUs'
import Solutions from './Solutions'
import Software from './Software'
import Hardware from './Hardware'
import News from './News'
export default {
  name: 'HomePage',
  components: { AboutUs, Solutions, Software, Hardware, News },
  data() {
    return {
      imgList: [require('../../assets/banner1.jpg'), require('../../assets/banner3.jpg'), require('../../assets/banner2.jpg')]
    }
  },
  methods: {
    clickContent(selMenu, subId, params) {
      this.$emit('clickHome', selMenu, subId, params)
    }
  }
}
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/HomePage.vue